import { useQueryParams } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { PartnerService } from '../../../services';
import { useEffect } from 'react';

const usePartnerParams = (): any => {
  const { dispatchAppStore, appStore } = useGlobalState();
  const { partner = null, subscription } = useQueryParams<{ partner: string; subscription: string }>();

  useEffect(() => {
    if (!partner && !appStore.partner) return;
    if (!partner && appStore.partner) {
      dispatchAppStore('partner', undefined);
      return;
    }
    if (appStore.partner?.slug === partner) return;

    PartnerService.getPartnerBySlug(partner!).then((res) => {
      dispatchAppStore('partner', res);
    });
  }, [partner, appStore, dispatchAppStore]);

  useEffect(() => {
    if (!subscription) return;
    dispatchAppStore('subscription', subscription);
  }, [subscription, dispatchAppStore]);
};

export default usePartnerParams;
